import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SKILLS_CREATOR_LANDING_URL } from '../../../utils/brand';
import { BaseButton, trackCtaClick } from '@repo/common';
import { ReactComponent as ArrowRightIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-right.svg';
import { ReactComponent as NavigationRightIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-right.svg';
import heroImage from '@repo/common/assets/images/bussiness_home_hero_img.svg';
import benefitsBackground from '@repo/common/assets/images/business_home_benefits_bg.jpeg';
import StepCard from '../../Kpathport/Rewards/StepCard';
import './BusinessHome.css';

const CONTACT_EMAIL = 'contact@ko-ready.com';

const cx = (...classes) => classes.filter(Boolean).join(' ');
const Next = `${process.env.REACT_APP_ASSETS_URL}/Kpathport/icon-next.svg`;

const AUDIENCES = [
  { key: 'user', label: 'For User' },
  { key: 'creator', label: 'For Business' },
  // 이 탭만 화면을 바꾸지 않고 Koready Skills 크리에이터 랜딩으로 보낸다
  { key: 'company', label: 'For Creator', href: SKILLS_CREATOR_LANDING_URL },
];

const goToAudienceLink = (audience) => {
  trackCtaClick({
    button_name: 'home_tab_for_creator',
    section: 'home_audience_tabs',
    page_path: window.location.pathname,
  });
  window.location.assign(audience.href);
};


const BENEFITS = [
  {
    title: '채용 공고 SNS 무료 홍보',
    description:
      '코레디에 게시한 채용 공고를 SNS 채널에도 무료로 소개해 더 많은 외국인 인재에게 알립니다.',
  },
  {
    title: '첫 채용 성공 수수료 0원',
    description:
      '초기 파트너 기업은 첫 번째 공고를 통해 채용이 성사되면 성공 수수료 면제 혜택을 제공해드립니다.',
  },
  {
    title: '외국인 채용 경로 안내',
    description:
      '기업의 상황과 고용 형태에 맞는 외국인 인재 채용 경로를 진단하고 안내합니다. Pathfinder by Koready는 곧 오픈됩니다.',
  },
  {
    title: '검증된 글로벌 인재',
    description:
      '시장 적합성을 검증하고 커리어 교육을 통해 업무 준비도를 높인 글로벌 인재를 연결합니다. 코레디는 단순 HR플랫폼이 아닌, 준비된 인재를 제공하는 NO.1 외국인 인재 플랫폼이 될 것입니다.',
  },
];

const PARTNERS = [
  { title: ['(주)온유'], detail: '전통문화 프로그램 협업 진행' },
  {
    title: ['Sunny House', '문화교류회'],
    detail: '문화 교류 프로그램 협업 진행',
  },
  { title: ['OO 다문화 센터'], detail: '글로벌 인재 프로그램 협업 진행' },
  { title: ['가온 행정사'], detail: '외국인 체류 행정 협업 진행' },
  { title: ['가온 공인중개사'], detail: '정착 지원 협업 진행' },
  {
    title: ['수원소재 전통문화카페', '온유여월'],
    detail: '전통문화 콘텐츠 협업 진행',
  },
];

const ScrollHint = () => (
  <span className='flex items-center gap-1 typo-b11 text-text-placeholder tabletH:hidden'>
    scroll
    <NavigationRightIcon aria-hidden='true' className='size-4' />
  </span>
);

const TalentCardTitle = ({ english, korean }) => (
  <>
    {english ? (
      <span className='typo-title3 tabletH:typo-title1'>{english}</span>
    ) : null}
    <span className='typo-krTitle3 tabletH:typo-krTitle1'>{korean}</span>
  </>
);

const BusinessTalentPipeline = () => (
  <section className='flex flex-col gap-5 overflow-hidden px-2 pb-6 mobile:px-4 tabletH:gap-6 tabletH:px-6 tabletH:pb-20 tabletV:gap-8 tabletV:px-[26px] desktopL:px-20'>
    <h2 className='m-0 text-center typo-krH7 text-green-deep02 mobile:typo-krH5 tabletH:typo-krH3 tabletV:typo-h2'>
      <span className='block tabletH:inline'>코레디가 준비한 </span>
      <span className='block tabletH:inline'>인재는 다릅니다</span>
    </h2>

    <div className='-mx-2 overflow-x-auto business-talent-scroll px-7 pb-14 mobile:-mx-4 mobile:px-9 tabletH:mx-0 tabletH:overflow-visible tabletH:px-0 tabletH:pb-0'>
      <div className='mx-auto flex w-max max-w-[1060px] items-center tabletH:w-full tabletH:flex-wrap tabletH:justify-center tabletH:gap-y-6'>
        <StepCard
          className='shadow-popup-02'
          layout='business'
          variant='completion'
          interactive={false}
          stepLabel='step 01'
          title={<TalentCardTitle english='Pathfinder' korean='준비도 진단' />}
          description='역량·비자·서류 갭 파악, 시장 적합성 검증'
          footer={<ScrollHint />}
        />
        <div className='flex h-[240px] w-5 shrink-0 items-center overflow-hidden tabletH:h-[300px] tabletH:w-10'>
          <img
            src={Next}
            alt=''
            aria-hidden='true'
            className='h-[300px] w-[43px] max-w-none shrink-0 tabletH:size-full'
          />
        </div>
        <StepCard
          className='shadow-popup-02'
          layout='business'
          variant='completion'
          interactive={false}
          stepLabel='step 02'
          title={
            <TalentCardTitle
              english='Koready Skills'
              korean='학습으로 갭 보완'
            />
          }
          description='채용 리스크 감소, 온보딩 부담 완화'
        />
        <div className='flex h-[240px] w-5 shrink-0 items-center overflow-hidden tabletH:h-[300px] tabletH:w-10'>
          <img
            src={Next}
            alt=''
            aria-hidden='true'
            className='h-[300px] w-[43px] max-w-none shrink-0 tabletH:size-full'
          />
        </div>
        <StepCard
          className='shadow-popup-02'
          layout='business'
          variant='ongoing'
          interactive={false}
          stepLabel='step 03'
          title={
            <TalentCardTitle
              korean={
                <>
                  즉시 투입 가능한
                  <br />
                  인재 연결
                </>
              }
            />
          }
        />
      </div>
    </div>
  </section>
);

const PartnerCard = ({ partner }) => (
  <article
    className={cx(
      'flex h-[90px] w-[170px] shrink-0 flex-col items-center justify-center gap-1.5 overflow-hidden rounded-[15px] bg-grayscale-gray00 px-3 py-2 text-center tabletV:h-[100px] tabletV:w-[200px] tabletV:px-6 tabletV:py-4',
    )}
  >
    <h3 className='w-full m-0 shrink-0 typo-krSmallStrong text-text-primary tabletV:typo-krDefaultStrong'>
      {partner.title.map((line) => (
        <span key={line} className='block'>
          {line}
        </span>
      ))}
    </h3>
    <p className='w-full m-0 truncate shrink-0 typo-krCaption text-text-secondary'>
      {partner.detail}
    </p>
  </article>
);

const PartnerGroup = ({ duplicate = false }) => (
  <div
    className='business-partners-group'
    aria-hidden={duplicate ? 'true' : undefined}
  >
    {PARTNERS.map((partner, index) => (
      <PartnerCard
        key={`${partner.title.join('-')}-${index}`}
        partner={partner}
      />
    ))}
  </div>
);

const AudienceTabs = ({ onAudienceChange }) => {
  const [activeAudience, setActiveAudience] = useState('creator');
  const transitionTimerRef = useRef(null);
  const activeAudienceIndex = Math.max(
    0,
    AUDIENCES.findIndex(({ key }) => key === activeAudience),
  );

  useEffect(
    () => () => {
      if (transitionTimerRef.current) {
        clearTimeout(transitionTimerRef.current);
      }
    },
    [],
  );

  const handleAudienceChange = (audience) => {
    if (audience.disabled || audience.key === activeAudience) return;
    if (audience.href) {
      goToAudienceLink(audience);
      return;
    }

    setActiveAudience(audience.key);
    if (transitionTimerRef.current) {
      clearTimeout(transitionTimerRef.current);
    }

    const prefersReducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    transitionTimerRef.current = setTimeout(
      () => onAudienceChange?.(audience.key),
      prefersReducedMotion ? 0 : 300,
    );
  };

  return (
    <div
      className='relative z-10 flex w-full box-border rounded-full bg-surface-black40 p-0.5 backdrop-blur-md mobileMini:max-w-[328px] mobile:max-w-[320px] tabletH:max-w-[440px] tabletV:max-w-[542px] tabletV:p-[3px] desktopL:max-w-[628px] desktopL:p-1 desktopXXL:max-w-[800px]'
      role='tablist'
      aria-label='Choose home audience'
    >
      <div className='relative flex w-full gap-1'>
        <span
          aria-hidden='true'
          className='absolute inset-y-0 left-0 transition-transform duration-300 ease-in-out rounded-full pointer-events-none bg-surface-gray60 shadow-3 motion-reduce:transition-none'
          style={{
            width: `calc((100% - ${(AUDIENCES.length - 1) * 4}px) / ${AUDIENCES.length})`,
            transform: `translateX(calc(${activeAudienceIndex * 100}% + ${activeAudienceIndex * 4}px))`,
          }}
        />

        {AUDIENCES.map((audience) => {
          const selected = audience.key === activeAudience;
          return (
            <BaseButton
              key={audience.key}
              type='text'
              size='s'
              typo={false}
              hideIcon
              isStatic
              role='tab'
              aria-selected={selected}
              aria-disabled={audience.disabled}
              tabIndex={audience.disabled ? -1 : undefined}
              onClick={() => handleAudienceChange(audience)}
              className={cx(
                'relative z-[1] h-auto min-w-0 flex-1 rounded-full border-0 bg-transparent p-1.5 text-center typo-b12Strong transition-colors duration-200 motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-deep01 tabletH:typo-b13Strong tabletV:p-2 desktopL:typo-b14Strong desktopXXL:px-3 desktopXXL:py-2.5',
                selected
                  ? 'text-text-inverse'
                  : 'text-grayscale-gray04 hover:text-text-inverse',
                audience.disabled
                  ? 'cursor-not-allowed opacity-60'
                  : 'cursor-pointer',
              )}
            >
              {audience.label}
            </BaseButton>
          );
        })}
      </div>
    </div>
  );
};

const BusinessHome = ({ onAudienceChange }) => {
  const navigate = useNavigate();

  const handleStart = (section) => {
    const destination = '/register?type=business';
    trackCtaClick({
      button_name: 'business_start_free',
      section,
      page_path: window.location.pathname,
      destination,
    });
    navigate(destination);
  };

  const handleInquiry = (section) => {
    const destination = `mailto:${CONTACT_EMAIL}`;
    trackCtaClick({
      button_name: 'business_inquiry',
      section,
      page_path: window.location.pathname,
      destination,
    });
    window.location.href = destination;
  };

  return (
    <main className='flex flex-col overflow-hidden bg-bg-twodays'>
      <section className='relative flex flex-col items-center gap-[60px] overflow-hidden px-4 pb-[100px] pt-[30px] tabletH:gap-[60px] tabletH:px-6 tabletH:pb-40 tabletH:pt-10 tabletV:gap-20 tabletV:px-10 tabletV:pb-[260px] tabletV:pt-[30px] desktopL:px-20 desktopL:pt-[60px] desktopXXL:gap-[100px] desktopXXL:pb-[320px]'>

        <div className='absolute inset-0 overflow-hidden' aria-hidden='true'>
          <img
            src={heroImage}
            alt=''
            className='absolute h-auto max-w-none w-[225.41%] left-[-86.2%] top-[-9.6%] min-[414px]:w-[202.14%] min-[414px]:left-[-73.87%] min-[414px]:top-[-6.96%] tabletH:w-[153.47%] tabletH:left-[-44.48%] tabletH:top-[-15.43%] tabletV:w-[119.43%] tabletV:left-[-19.41%] tabletV:top-[-17.9%] desktopL:w-[118.89%] desktopL:left-[-18.89%] desktopL:top-[-19.57%] desktopXXL:w-[122.27%] desktopXXL:left-[-22.27%] desktopXXL:top-[-32.69%]'
          />
        </div>
        <div className='absolute inset-0 bg-surface-black60' />

        <AudienceTabs onAudienceChange={onAudienceChange} />

        <div className='relative z-10 flex w-full flex-col items-center gap-10 text-center tabletH:gap-[50px]'>
          <div className='flex flex-col gap-2 tabletH:gap-3 desktopL:gap-4'>
            <h1 className='m-0 typo-krH6 text-text-inverse tabletH:typo-krH3'>
              글로벌 인재를 만날 준비
              <br />
              코레디에서 시작하세요
            </h1>
            <p className='m-0 typo-krCaption text-grayscale-gray04 tabletH:typo-krDefault'>
              <span className='block mobile:inline'>
                정규직부터 프리랜서까지,{' '}
              </span>
              <span className='block mobile:inline'>
                필요한 외국인 인재를 코레디에서 찾아보세요
              </span>
            </p>
          </div>

          <div className='flex w-full max-w-[320px] flex-col items-center gap-3 tabletH:w-auto tabletH:max-w-none tabletH:flex-row tabletH:gap-2'>
            <BaseButton
              type='primary'
              size='m'
              mode='dark'
              lang='kr'
              hideIcon
              rounded='pill'
              onClick={() => handleStart('business_hero')}
            >
              무료로 시작하기
            </BaseButton>
            <BaseButton
              type='secondary'
              size='m'
              mode='dark'
              lang='kr'
              hideIcon
              rounded='pill'
              onClick={() => handleInquiry('business_hero')}
            >
              도입 문의하기
            </BaseButton>
            <span className='hidden tabletH:inline-flex'>
              <BaseButton
                type='secondary'
                size='m'
                mode='dark'
                lang='kr'
                hideIcon
                rounded='pill'
              >
                서비스 소개서 받기
              </BaseButton>
            </span>
          </div>
        </div>
      </section>

      <section className='flex flex-col gap-5 px-4 pb-10 pt-20 text-center tabletH:gap-[30px] tabletH:px-6 tabletH:pb-20 tabletH:pt-[120px] tabletV:gap-9 tabletV:px-10 desktopL:px-20'>
        <h2 className='m-0 typo-krTitle2 text-text-primary tabletH:typo-krH7 tabletV:typo-krH5'>
          국내에서 외국인 채용이 어려운 이유
        </h2>
        <div className='flex flex-col items-center gap-4 tabletV:gap-6'>
          <p className='m-0 typo-krSmallStrong text-text-primary tabletH:typo-krDefaultStrong tabletV:typo-krTitle3'>
            이력서만으론 실제 역량·한국어 수준 검증 불가
          </p>
          <p className='m-0 typo-krSmallStrong text-text-tertiary tabletH:typo-krDefaultStrong tabletV:typo-krTitle3'>
            비자·체류자격이 복잡하고 리스크가 큼
          </p>
          <p className='m-0 typo-krSmallStrong text-text-secondary tabletH:typo-krDefaultStrong tabletV:typo-krTitle3'>
            입사 후 조기 이탈·적응 실패
          </p>
          <div
            className='flex flex-col items-center gap-[15px] py-5'
            aria-hidden='true'
          >
            <span className='size-1.5 rounded-full bg-grayscale-gray03' />
            <span className='size-1.5 rounded-full bg-grayscale-gray04' />
            <span className='size-1.5 rounded-full bg-grayscale-gray05' />
          </div>
        </div>
      </section>

      <BusinessTalentPipeline />

      <section className='relative flex flex-col items-center gap-5 overflow-hidden px-4 py-10 text-center tabletH:gap-[50px] tabletH:px-6 tabletH:pb-[100px] tabletH:pt-20 tabletV:px-10 desktopL:px-20'>
        <img
          src={benefitsBackground}
          alt=''
          aria-hidden='true'
          className='absolute inset-0 object-cover size-full'
        />
        <div className='absolute inset-0 bg-surface-black80' />
        <h2 className='relative z-10 m-0 text-text-inverse'>
          <span className='block typo-h7 tabletV:typo-h5'>
            인재의 준비는 탄탄하게
          </span>
          <span className='block typo-krH5 text-green-deep01 tabletV:typo-krH3'>
            기업의 준비는 수월하게
          </span>
        </h2>
        <div className='relative z-10 grid w-full max-w-[1460px] grid-cols-1 gap-3 tabletH:gap-4 tabletV:grid-cols-2 tabletV:gap-[18px] desktopL:gap-6'>
          {BENEFITS.map((benefit) => (
            <article
              key={benefit.title}
              className='flex flex-col gap-3 rounded-[15px] bg-white/[0.02] p-[30px] text-center backdrop-blur-[40px] tabletH:gap-4 tabletV:p-[34px]'
            >
              <h3 className='m-0 typo-krDefaultStrong text-text-inverse tabletH:typo-krTitle1 desktopL:typo-krH7'>
                {benefit.title}
              </h3>
              <p className='m-0 typo-krSmall text-grayscale-gray04'>
                {benefit.description}
              </p>
            </article>
          ))}
        </div>
      </section>

      <section className='flex flex-col gap-3 overflow-hidden px-4 py-[60px] text-center tabletH:gap-6 tabletH:px-6 tabletH:pb-[100px] tabletH:pt-20 tabletV:px-10 tabletV:pb-[120px] tabletV:pt-[100px] desktopL:px-20'>
        <h2 className='m-0 typo-krDefaultStrong text-text-primary tabletH:typo-krTitle3 tabletV:typo-krTitle1'>
          파트너사
        </h2>
        <div className='business-partners-marquee' aria-label='파트너사 목록'>
          <div className='business-partners-track'>
            <PartnerGroup />
            <PartnerGroup duplicate />
          </div>
        </div>
      </section>

      <section className='relative flex flex-col items-center gap-4 overflow-hidden bg-green-deep01 px-4 py-[60px] text-center tabletH:gap-[26px] tabletH:px-6 tabletH:py-20 tabletV:gap-8 tabletV:px-10 tabletV:py-[100px] desktopL:px-20'>
        <div
          className='absolute inset-0 business-cta-glow'
          aria-hidden='true'
        />
        <h2 className='relative z-10 m-0 typo-krTitle2 text-green-deep05 tabletH:typo-krH5'>
          얼리 파트너십으로 혜택을 누려보세요
        </h2>
        <div className='relative z-10 flex items-center gap-2'>
          <BaseButton
            type='primary'
            size='l'
            lang='kr'
            rounded='pill'
            icon={null}
            iconAfter={<ArrowRightIcon aria-hidden='true' className='size-4' />}
            onClick={() => handleStart('business_early_partnership')}
            bgclass='bg-surface-gray60 hover:bg-grayscale-gray08 active:bg-grayscale-gray09'
            textclass='text-grayscale-gray00'
            className='shadow-2'
          >
            무료로 시작하기
          </BaseButton>
          <BaseButton
            type='secondary'
            size='l'
            lang='kr'
            hideIcon
            rounded='pill'
            onClick={() => handleInquiry('business_early_partnership')}
          >
            도입 문의하기
          </BaseButton>
        </div>
      </section>
    </main>
  );
};

export default BusinessHome;
